import i18n from '../i18n';

export const RATE_FORM_WIZARD_STEPS = {
  RATE_FORM: '1',
  PAYROLL_FILE: '2',
  CPM_COMPLIANCE: '3',
  SELECT_STANDARD_VEHICLE: '3',
  COMPLIANCE: '4',
  REVIEW: '5',
};

export const APPROVAL_CONFIG_VALUES = {
  MANUAL: 'manual',
  SEMI: 'semi',
  AUTO: 'auto',
  AUTO_VALUES: {
    MILES_LESS_THAN: 1,
    CUSTOM: 2,
  },
};

export const SEMI_AUTO_VALUES = {
  DISTANCE: 'distance',
  GPS: 'gps_percentage',
  REIMBURSEMENT: 'reimbursement',
};

export const RATE_TYPES = {
  FAVR: 'favr',
  GOVT: 'govt',
  FLAT: 'flat',
  TIERED: 'band',
};

export const RATE_TYPE_OPTIONS = [
  {
    label: i18n.t('favrRate'),
    value: RATE_TYPES.FAVR,
  },
  {
    label: i18n.t('flatCpmRate'),
    value: RATE_TYPES.FLAT,
  },
  {
    label: i18n.t('governmentRate'),
    value: RATE_TYPES.GOVT,
  },
  {
    label: i18n.t('tieredRate'),
    value: RATE_TYPES.TIERED,
  },
];
